// extracted by mini-css-extract-plugin
export default {"icon":"ItemList_icon__V7G0u","body":"ItemList_body__6M05g","wrap":"ItemList_wrap__kMXaH"};